/* istanbul ignore file */
import type {ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {getResponsiveLayoutShouldRenderVars} from '../../../productPage/components/Layouts/ResponsiveLayout/ResponsiveLayout.cssVars';
import {getProductGalleryLayoutShouldRenderVars} from '../../../productPage/components/ProductGallery/ProductGalleryLayout/ProductGalleryLayout.cssVars';
import {getProductPageButtonContainerShouldRenderVars} from '../../../productPage/components/ProductPageButtonsContainer/ProductPageButtonContainer.cssVars';
import type {BooleanStyleParamsKeys} from '../stylesParams';

export type ShouldRenderVarsKeys = keyof ReturnType<typeof getShouldRenderVars> | BooleanStyleParamsKeys;

export const getShouldRenderVars = (shouldRenderVarsFnParams: ShouldRenderVarsFnParams) => {
  return {
    ...getProductPageButtonContainerShouldRenderVars(shouldRenderVarsFnParams),
    ...getResponsiveLayoutShouldRenderVars(shouldRenderVarsFnParams),
    ...getProductGalleryLayoutShouldRenderVars(shouldRenderVarsFnParams),
  };
};
